import { GenericFieldOrder } from '@/hooks/invoice_reports/useShowSearchValue';
import { useTranslation } from '@/i18n';
import { useMemo } from 'react';

/**
 * Custom hook for invoice_reports field orders
 * Field order and labels match SearchForm layout (useConfigForm labels).
 * Conditional visibility (e.g. agent) is handled via dynamic excludeFields in Search.
 */
export const useInvoiceReportsFieldOrders = () => {
  const { t } = useTranslation();
  const FIELD_ORDERS: GenericFieldOrder[] = useMemo(
    () => [
      // Row 1: キーワード, 請求書番号, 申請状態, 申請者, 支払状況, 添付請求書
      { key: 'query', label: t('invoice_reports.search.keyword') },
      { key: 'number', label: t('invoice_reports.search.number') },
      { key: 'status', label: t('invoice_reports.search.status') },
      {
        key: 'agent_applicant_office_member_ids',
        label: t('invoice_reports.search.agent_applicant_office_member'),
      },
      {
        key: 'payment_status',
        label: t('invoice_reports.search.payment_status'),
      },
      { key: 'mf_file', label: t('invoice_reports.search.mf_file') },
      // Row 2: 支払先, 合計金額, 作成日, 申請日
      {
        key: 'ap_payee_ids',
        label: t('invoice_reports.search.ap_payee'),
        concatChar: '、',
      },
      {
        key: ['total_amount_from', 'total_amount_to'],
        label: t('invoice_reports.search.total_amount'),
        concatChar: ' ~ ',
        canShowPartialValue: true,
        isAmountField: true,
      },
      {
        key: ['created_at_from', 'created_at_to'],
        label: t('invoice_reports.search.created_date'),
        concatChar: ' - ',
        isDateField: true,
      },
      {
        key: ['submitted_at_from', 'submitted_at_to'],
        label: t('invoice_reports.search.submitted_date'),
        concatChar: ' - ',
        isDateField: true,
      },
      // Row 3: 承認日, 費用計上日, 支払期日, 支払日
      {
        key: ['approved_at_from', 'approved_at_to'],
        label: t('invoice_reports.search.approved_date'),
        concatChar: ' - ',
        isDateField: true,
      },
      {
        key: ['book_date_from', 'book_date_to'],
        label: t('invoice_reports.search.book_date'),
        concatChar: ' - ',
        isDateField: true,
      },
      {
        key: ['due_date_from', 'due_date_to'],
        label: t('invoice_reports.search.due_date'),
        concatChar: ' - ',
        isDateField: true,
      },
      {
        key: ['payment_date_from', 'payment_date_to'],
        label: t('invoice_reports.search.payment_date'),
        concatChar: ' - ',
        isDateField: true,
        canShowPartialValue: true,
      },
    ],
    [t]
  );

  return { FIELD_ORDERS };
};
